import React from 'react'
import './HomeAboutme.scss'
import mac from './assets/maxc.jpg'
import duteam from './assets/duteam.jpg'
import mirror from './assets/mirror.jpg'

function HomeAboutme() {

    return (

        <div className='abtme-mastercontainer'>



            <section className="HomeAboutme max-width-aboutmehome" >




                <img src={mirror} id='imgleft'   alt=""/>



                <div id='textaboutme'>
                    <h5 className='bottom-xs'>Get to know me </h5>

                    <p className="bottom-m ">I am a generalist at heart, i got into product design because it allowed me to pursue my interest in creative, tech and business field. I’ve since worked on a range of problem for various industries including - telecom, AI, finance, Internal tools, ERPs etc. i am looking for impactful, purposeful work with a diverse team of talented people.</p>

                    <button className='secondary'>Read about me and my interests - coming soon</button>
                </div>


                <img src={mac} id='imgright'  alt="" />

                <img src={duteam} id='imgbottom'   alt=""/>







                Junaid mohamed
            </section>

        </div>

    )

}

export default HomeAboutme